// src/App.js
// THE ROUTER (WU-145 UNIT 3 THE SWITCH, docs/manifest/WU-145.md SESSION 1 RECORD THE DESIGN SO FAR D1): ventaje.com's home page is
// the designer's landing, and the new onboarding and the public pages render inside RedesignFrame, the class his rules need on
// <html>. The old flow is no longer routed; its files stay in the repo until its removal (UNIT 4, deferred), so the way back is
// this commit's one revert (D6). Every old address keeps answering (S-6), each proven by src/App.routes.test.js.
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import RedesignFrame from './components/redesign/RedesignFrame';
import MarketingLandingPage from './pages/misc/LandingPage';
import StructureBuilderPage from './pages/misc/onboarding/StructureBuilderPage';
import CreateOrganizationPlanPage from './pages/settings/create-organization/CreateOrganizationPlanPage';
import CreateOrganizationExtensionsPage from './pages/settings/create-organization/CreateOrganizationExtensionsPage';
import OnboardingAccountPage from './pages/misc/onboarding/OnboardingAccountPage';
import CreateOrganizationBillingPage from './pages/settings/create-organization/CreateOrganizationBillingPage';
import OnboardingReturnPage from './pages/misc/onboarding/OnboardingReturnPage';
import OnboardingResumePage from './pages/misc/onboarding/OnboardingResumePage';
import OnboardingPlainReturnPage from './pages/misc/onboarding/OnboardingPlainReturnPage';
import SociosPage from './pages/misc/public/SociosPage';
import ComoFuncionaPage from './pages/misc/public/ComoFuncionaPage';
import ArticlePage from './pages/misc/public/ArticlePage';
import FaqPage from './pages/misc/public/FaqPage';
import ContactPage from './pages/misc/public/ContactPage';

const RESUME_ROUTE = '/onboarding/continuar';

// The `/` door (D3, D4): the old addresses that carry a query. `?resume=<id>` (the app's login card builds it) goes on to the one
// resume screen with its query unchanged; `?status=success|cancelled` (Stripe's return for the old lane and for staff-provisioned
// Elite) shows the plain return screen, which reads no id; anything else is the landing. An id names one application, so `resume`
// is read first.
function HomeDoor() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  if (params.has('resume')) return <Navigate to={{ pathname: RESUME_ROUTE, search }} replace />;
  const status = params.get('status');
  if (status === 'success' || status === 'cancelled') return <OnboardingPlainReturnPage cancelled={status === 'cancelled'} />;
  return <MarketingLandingPage />;
}

// `/landing` was the landing's address before the switch, and his files link to it with a hash (`/landing#cuestionario`): it goes
// to `/` keeping the hash (S-6).
function LandingRedirect() {
  const { hash } = useLocation();
  return <Navigate to={{ pathname: '/', hash }} replace />;
}

// Main App Component with Router
function App() {
  return (
    <LanguageProvider>
    <Router>
      <Routes>
        <Route element={<RedesignFrame />}>
          <Route path="/" element={<HomeDoor />} />
          <Route path="/onboarding" element={<StructureBuilderPage />} />
          <Route path="/onboarding/plan" element={<CreateOrganizationPlanPage />} />
          <Route path="/onboarding/extensiones" element={<CreateOrganizationExtensionsPage />} />
          <Route path="/onboarding/cuenta" element={<OnboardingAccountPage />} />
          <Route path="/onboarding/checkout" element={<CreateOrganizationBillingPage />} />
          <Route path="/onboarding/estado" element={<OnboardingReturnPage />} />
          <Route path={RESUME_ROUTE} element={<OnboardingResumePage />} />
          <Route path="/socios" element={<SociosPage />} />
          <Route path="/como-funciona" element={<ComoFuncionaPage />} />
          <Route path="/como-funciona/:slug" element={<ArticlePage />} />
          <Route path="/preguntas" element={<FaqPage />} />
          <Route path="/contacto" element={<ContactPage />} />
        </Route>
        <Route path="/landing" element={<LandingRedirect />} />
        <Route path="/programa-referidos" element={<Navigate to="/socios" replace />} />
        {/* every other address - the old flow's pages and /dashboard among them (S-6) - goes to the home page */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
    </LanguageProvider>
  );
}

export default App; 